import http from 'hub-http/clients/apiClient';
const BASE_URL = '/filemanager/api/v2';
const BASE_PATH = '/form-uploads';
export function getFileManagerUrls(formGuids) {
  return http.get(`${BASE_URL}/folders/info/multiple`, {
    query: {
      path: formGuids.map(formGuid => `${BASE_PATH}/${formGuid}`)
    }
  });
}
export function getFileByPath(path) {
  return http.get(`filemanager/api/v2/files/info/form-uploads/${path}`);
}
export function getFileById(id) {
  return http.get(`filemanager/api/v2/files/${id}`);
}